/**
 * List component for transactions, managing list content and implementing event handler
 * 
 * Properties:
 * 
 *      wallets:    array, array of objects containing wallet transactions
 *      dispatch:   function, common dispatch function
 */

import React from "react";

import VoucherListItem from "./VoucherListItem";
 
 const VouchersList = (props) => {
     const {
         vouchers,
         dispatch,
         filterChangedHandle,
         filter,
         onRemoveVoucher,
         setIndex,
         setInitialized,
         showNotification } = props;
     return (
         <>
             <div id="inb-c-main-vouchers" className="inb-c-listing off-canvas-content" data-off-canvas-content="" key="inb-c-main-vouchers">
             <br/>
                 {vouchers.map((voucher, index) => {
                     return (<>
                             <VoucherListItem
                                 voucher={vouchers[index]}
                                 key={index+`_res`}
                                 index={index}
                                 filterChangedHandle={filterChangedHandle}
                                 filter={filter}
                                 dispatch={dispatch}
                                 onRemoveVoucher={onRemoveVoucher}
                                 setIndex={setIndex}
                                 _index={index}
                                 setInitialized={setInitialized}
                                 showNotification={showNotification}
                             />
                         </>
                     )
                 }
             )}
             </div>
         </>
     );
 }
 export default VouchersList;